export default __webpack_public_path__ + "static/media/icon-caution-yellow.2140b1f1.svg";